import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';

const Rep_knockoff = () => {
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [counter, setCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [generateType, setGenerateType] = useState("V");
    const [scr, setScr] = useState("");
    const [locationType, setLocationType] = useState("O");
    const [locationCode, setLocationCode] = useState(0);
    const [trailLocation, setTrailLocation] = useState(null);


    const [onceRun, setOnceRun] = useState(false);

    var msg = [], i = 0;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setTrailLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_KNOCKOFF'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);
    const handleChangeLocation = (value) => {
        setTrailLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleGenerate = () => {

        $(".loader").show();
        if (fromDate == null || toDate == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate == null ? "Please select from date." : '');
            msg[i++] = (toDate == null ? "Please select to date." : '');
            $(".loader").hide();

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            const obj = {
                locationType: locationType,
                location: locationCode,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                showHeader: true,
            }
            console.log(obj);
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apirepknockoff, "post", [sid, "download", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apirepknockoff, [sid, "viewdata", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                {scr === "" ?
                    <>
                        <Row>
                            <Col>
                                <h2>KnockOff Report<span style={{ color: "#f8f9fd" }}>{counter}</span> </h2>
                            </Col>
                        </Row>&nbsp;

                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={locationType} onChange={e => setLocationType(e.target.value)}
                                        required>
                                        <option value="A">All</option>
                                        <option value="O">One</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {locationType === 'O' ? <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={trailLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col></> : null}
                        </Row>&nbsp;

                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={fromDate}
                                        onChange={(date) => setFromDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={toDate}
                                        onChange={(date) => setToDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {
                                /*
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label><br />
                                        <select class="form-select" aria-label="Default select example" value={typeOptionTrail}
                                            onChange={(e) => handleTypeChange(e)} >
                                            <option value="L">Ledger</option>
                                            <option value="G">Group</option>
                                        </select>
                                    </Col>
                                */
                            }
                            <Col></Col>

                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                        required>
                                        <option value="V">View</option>
                                        <option value="D">Download</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>&nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}
                                >Generate</Button>
                            </Col>
                        </Row>
                    </> : null}
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>


            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div>
    )
}

export default Rep_knockoff
